module.exports = __webpack_public_path__ + "img/stat-icon-4.ee2e7c64.png";